// src/analytics.js
import ReactGA from 'react-ga';

const trackingId = "G-X7KLBG85EM"; // Replace with your tracking ID
ReactGA.initialize(trackingId);

export const trackPageView = (page) => {
  ReactGA.pageview(page);
};
